import { Config } from '../../_config'
import { UseCase } from '../../_kernel/architecture'
import { ID } from '../../_kernel/ID'
import { ListOfProperty } from '../domain/ListOfProperty'
import { PropertyRepository } from '../domain/PropertyRepository'
import { PropertyRepositoryProxy } from '../infrastructure/PropertyRepositoryProxy'
import GetCurrentLanguageSharedUseCase from '../../shared/application/GetCurrentLanguageSharedUseCase'
import GetCurrentMarketSharedUseCase from '../../shared/application/GetCurrentMarketSharedUseCase'
import GetCurrentPartialSearchSharedUseCase from '../../shared/application/GetCurrentPartialSearchSharedUseCase'
import GetCurrentAffiliateSharedUseCase from '../../shared/application/GetCurrentAffiliateSharedUseCase'
import { Currency } from '../../_kernel/Currency'
import { Country } from '../../_kernel/Country'

export interface GetRelatedPropertyUseCaseInput {
  id: string
}

export default class GetRelatedPropertyUseCase
  implements UseCase<GetRelatedPropertyUseCaseInput, ListOfProperty>
{
  static readonly USE_CASE_NAME = 'GetRelatedPropertyUseCase'
  static create({
    config,
    languageUseCase,
    marketUseCase,
    partialSearchUseCase,
    affiliateUseCase,
    repository,
  }: {
    config: Config
    languageUseCase?: GetCurrentLanguageSharedUseCase
    marketUseCase?: GetCurrentMarketSharedUseCase
    partialSearchUseCase?: GetCurrentPartialSearchSharedUseCase
    affiliateUseCase?: GetCurrentAffiliateSharedUseCase
    repository?: PropertyRepository
  }) {
    return new GetRelatedPropertyUseCase(
      languageUseCase ?? GetCurrentLanguageSharedUseCase.create({ config }),
      marketUseCase ?? GetCurrentMarketSharedUseCase.create({ config }),
      partialSearchUseCase ?? GetCurrentPartialSearchSharedUseCase.create({ config }),
      affiliateUseCase ?? GetCurrentAffiliateSharedUseCase.create({ config }),
      repository ?? PropertyRepositoryProxy.create({ config })
    )
  }

  constructor(
    private languageUseCase: GetCurrentLanguageSharedUseCase,
    private marketUseCase: GetCurrentMarketSharedUseCase,
    private partialSearchUseCase: GetCurrentPartialSearchSharedUseCase,
    private affiliateUseCase: GetCurrentAffiliateSharedUseCase,
    private repository: PropertyRepository
  ) {}

  async execute({ id }: GetRelatedPropertyUseCaseInput) {
    const [lang, market, partialSearch, affiliate] = await Promise.all([
      this.languageUseCase.execute(),
      this.marketUseCase.execute(),
      this.partialSearchUseCase.execute(),
      this.affiliateUseCase.execute(),
    ])

    return this.repository.relatedByID({
      id: ID.create({ value: id }),
      lang,
      market,
      partialSearch,
      affiliate,
      currency: Currency.fromMarket({ market }),
      country: Country.fromMarket({ market }),
    })
  }
}
